import { logout } from './api/logout';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useDefaultModal from './components/hooks/useDefaultModal';
import DefaultModal from './components/modals/DefaultModal';
import usePagination10 from './components/hooks/usePagination10';
import Pagination10 from './components/Pagination10';
import PageFooter from './components/PageFooter';
import Layout from './components/LayoutSelecionaUnidade';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';

function SelecionaEntidade() {
  const [UsuarioBinds, setUsuarioBinds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const navigate = useNavigate();

  // Carrega os dados do localStorage
  useEffect(() => {
    const storedOptions = localStorage.getItem('userBind');
    if (storedOptions) {
      try {
        const parsedOptions = JSON.parse(storedOptions);
        setUsuarioBinds(parsedOptions);
        
        // Se houver apenas 1 entidade, redirecionar automaticamente para /home
        if (parsedOptions.length === 1) {
          const selectedUsuarioBind = parsedOptions[0];
          localStorage.setItem(
            'appCliente',
            JSON.stringify(selectedUsuarioBind.appCliente)
          );
          localStorage.setItem('cnpj', selectedUsuarioBind.appCliente.cnpj);
          localStorage.setItem('usuarioBind', JSON.stringify(selectedUsuarioBind));
          navigate('/home');
        }
      } catch (error) {
        console.error('Erro ao parsear os dados do localStorage:', error);
      }
    }
  }, [navigate]);

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const filteredUsuarioBinds = UsuarioBinds.filter(option => {
    const normalizedBusca = normalizeString(searchTerm);
    return (
      normalizeString(option.appCliente.nome).includes(normalizedBusca) ||
      normalizeString(option.appCliente.logrCidade).includes(normalizedBusca) ||
      normalizeString(option.appCliente.cnpj).includes(normalizedBusca)
    );
  });

  const totalItems = filteredUsuarioBinds.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedUsuarioBinds = filteredUsuarioBinds.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const handleSelect = cnpj => {
    const selectedUsuarioBind = UsuarioBinds.find(
      option => option.appCliente.cnpj === cnpj
    );

    if (
      selectedUsuarioBind &&
      selectedUsuarioBind.appCliente.cnpj.length === 14
    ) {
      localStorage.setItem(
        'appCliente',
        JSON.stringify(selectedUsuarioBind.appCliente)
      );
      localStorage.setItem('cnpj', selectedUsuarioBind.appCliente.cnpj);
      localStorage.setItem('usuarioBind', JSON.stringify(selectedUsuarioBind));
      navigate('/home');
    } else {
      showDefaultModal('error', 'Por favor, selecione uma opção válida.');
    }
  };

  const handleLogout = () => {
    const token = localStorage.getItem('token');
    logout(token)
      .then(() => {
        localStorage.clear();
        try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
        navigate('/');
      })
      .catch(() => {
        localStorage.clear();
        try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
        navigate('/');
      });
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Entidades vinculadas ao Usuário" icon="bi-building" onLogout={handleLogout} onClose={handleLogout} backButton={false} />
        <PageContent style={{ paddingBottom: 0 }}>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div />
            <div className="d-flex align-items-center gap-2">
              <div style={{ position: 'relative' }}>
                <i className="bi bi-funnel" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }}></i>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  style={{ width: '320px', paddingLeft: '36px' }}
                  placeholder="CNPJ, Entidade ou Cidade"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer tableClass="table-custom-radius">
            <TableHeader columns={[
              { label: 'CNPJ', width: '15%' },
              { label: 'Entidade' },
              { label: 'Cidade' },
              { label: 'UF' },
              { label: 'Ação', width: '10%', align: 'center' },
            ]} />
            <tbody>
              {selectedUsuarioBinds.length > 0 ? (
                selectedUsuarioBinds.map((option, index) => (
                  <tr key={index}>
                    <td className="align-middle" style={{ width: '15%' }}>
                      {option.appCliente.cnpj}
                    </td>
                    <td className="align-middle">{option.appCliente.nome}</td>
                    <td className="align-middle">{option.appCliente.logrCidade}</td>
                    <td className="align-middle">{option.appCliente.logrUf}</td>
                    <td className="align-middle text-center" style={{ width: '10%' }}>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => handleSelect(option.appCliente.cnpj)}
                      >
                        <i className="bi bi-check2-circle me-1 d-none d-sm-inline"></i><span className="d-none d-sm-inline">Selecionar</span><i className="bi bi-check2-circle d-inline d-sm-none"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center align-middle text-muted py-4">
                    <i className="bi bi-inbox display-6 d-block mb-2"></i>
                    Nenhum registro encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </TableContainer>
          <DefaultModal {...setDefaultModal} />
        </PageContent>
        <PageFooter>
            <Pagination10 {...setPagination} />
          </PageFooter>
      </ResponsiveShadow>
    </Layout>
  );
}
export default SelecionaEntidade;
